export const primary01: string = '#ef672d'
export const primary02: string = '#bfbfbf'
export const primary03: string = '#004f83'
export const primary04: string = '#ce6f9b'
export const primary05: string = '#f3b640'

export const neutral01: string = '#000000'
export const neutral02: string = '#fff'

export const error: string = 'red'